import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { WalletServiceIndexResponse } from '@/repositories/generated';

const content: WalletServiceIndexResponse[] = [
  {
    id: '001',
    name: 'モックWS1',
    status: 'AVAILABLE',
    chargeMethods: ['STORE', 'BANK_ACCOUNT', 'CREDIT_CARD'],
    paymentMethods: ['PREPAID', 'DIRECT_BANK', 'CREDIT_CARD'],
    startDate: '2022-01-15',
    endDate: '2022-12-15',
  },
  {
    id: '002',
    name: 'モックWS2',
    status: 'AVAILABLE',
    chargeMethods: ['STORE'],
    paymentMethods: ['PREPAID'],
    startDate: '2022-01-15',
    endDate: '2022-12-15',
  },
  {
    id: '003',
    name: 'モックWS3',
    status: 'WAITING',
    chargeMethods: ['BANK_ACCOUNT', 'CREDIT_CARD'],
    paymentMethods: ['PREPAID', 'DIRECT_BANK'],
    startDate: '2022-01-15',
    endDate: '2022-12-15',
  },
  {
    id: '004',
    name: 'モックWS4',
    status: 'CLOSED',
    chargeMethods: ['STORE', 'CREDIT_CARD'],
    paymentMethods: ['CREDIT_CARD'],
    startDate: '2022-01-15',
    endDate: '2022-12-15',
  },
];

const loopContent = new Array<string>(50)
  .fill('')
  .map((_, i) => content[i % content.length]);

export const walletService = http.get(
  createMockEndpoint('/wallet_service'),
  async ({ request }) => {
    const url = new URL(request.url);
    await delay(500);
    const walletServiceExists = url.searchParams.get('walletServiceNames') ?? '';
    const issuerNameExists = url.searchParams.get('issuerNames') ?? '';
    const shopNameExists = url.searchParams.get('shopNames') ?? '';

    if (walletServiceExists || issuerNameExists || shopNameExists) {
    // クエリパラメータあり
      return HttpResponse.json({
        content: loopContent.slice(3, 25),
        pageable: {
          sort: {
            empty: true,
            sorted: false,
            unsorted: true,
          },
          offset: 0,
          pageNumber: 0,
          pageSize: 20,
          paged: true,
          unpaged: false,
        },
        last: true,
        totalPages: 1,
        totalElements: 20,
        size: 20,
        number: 0,
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        first: true,
        numberOfElements: 20,
        empty: false,
      }, { status: 200 });
    }
    // クエリパラメータなし
    return HttpResponse.json({
      content: loopContent,
      pageable: {
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        offset: 0,
        pageNumber: 0,
        pageSize: 20,
        paged: true,
        unpaged: false,
      },
      last: true,
      totalPages: 1,
      totalElements: 50,
      size: 50,
      number: 0,
      sort: {
        empty: true,
        sorted: false,
        unsorted: true,
      },
      first: true,
      numberOfElements: 50,
      empty: false,
    }, { status: 200 });
  },
);
